import { render } from "./pcDrawer.vue?vue&type=template&id=88758f24&scoped=true"
import script from "./pcDrawer.vue?vue&type=script&lang=js"
export * from "./pcDrawer.vue?vue&type=script&lang=js"

import "./pcDrawer.vue?vue&type=style&index=0&id=88758f24&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88758f24"]])

export default __exports__